<div class="relative">
  <div
    class="absolute top-2.5 right-2.5 z-10 flex justify-center items-center border border-solid border-primary rounded-lg text-sm h-8 w-8 font-semibold text-primary cursor-pointer hover:bg-primary-hover bg-white"
    (click)="openFullScreenMap()"
  >
    <mat-icon>fullscreen</mat-icon>
  </div>

  <google-map [height]="height()" width="full" [options]="options" [center]="location">
    <map-marker #markerElem="mapMarker" [options]="markerOptions" [position]="location" />
  </google-map>
</div>
